/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MetricValueJsonAggregatedValuesDto } from './MetricValueJsonAggregatedValuesDto';
import {
    MetricValueJsonAggregatedValuesDtoFromJSON,
    MetricValueJsonAggregatedValuesDtoFromJSONTyped,
    MetricValueJsonAggregatedValuesDtoToJSON,
    MetricValueJsonAggregatedValuesDtoToJSONTyped,
} from './MetricValueJsonAggregatedValuesDto';
import type { MetricValueTextAggregatedValuesDto } from './MetricValueTextAggregatedValuesDto';
import {
    MetricValueTextAggregatedValuesDtoFromJSON,
    MetricValueTextAggregatedValuesDtoFromJSONTyped,
    MetricValueTextAggregatedValuesDtoToJSON,
    MetricValueTextAggregatedValuesDtoToJSONTyped,
} from './MetricValueTextAggregatedValuesDto';
import type { MetricValueAggregatedValuesDto } from './MetricValueAggregatedValuesDto';
import {
    MetricValueAggregatedValuesDtoFromJSON,
    MetricValueAggregatedValuesDtoFromJSONTyped,
    MetricValueAggregatedValuesDtoToJSON,
    MetricValueAggregatedValuesDtoToJSONTyped,
} from './MetricValueAggregatedValuesDto';

/**
 * 
 * @export
 * @interface MetricValueAggregatedResponseDto
 */
export interface MetricValueAggregatedResponseDto {
    /**
     * ID
     * @type {number}
     * @memberof MetricValueAggregatedResponseDto
     */
    id?: number;
    /**
     * Patient ID
     * @type {string}
     * @memberof MetricValueAggregatedResponseDto
     */
    patientId: string;
    /**
     * Start date of the interval (ISO 8601 format)
     * @type {string}
     * @memberof MetricValueAggregatedResponseDto
     */
    startDate: string;
    /**
     * Aggregated integer values for this interval
     * @type {MetricValueAggregatedValuesDto}
     * @memberof MetricValueAggregatedResponseDto
     */
    valueIntData?: MetricValueAggregatedValuesDto;
    /**
     * Aggregated float values for this interval
     * @type {MetricValueAggregatedValuesDto}
     * @memberof MetricValueAggregatedResponseDto
     */
    valueFloatData?: MetricValueAggregatedValuesDto;
    /**
     * Aggregated text values for this interval
     * @type {MetricValueTextAggregatedValuesDto}
     * @memberof MetricValueAggregatedResponseDto
     */
    valueTextData?: MetricValueTextAggregatedValuesDto;
    /**
     * Aggregated JSON values for this interval
     * @type {MetricValueJsonAggregatedValuesDto}
     * @memberof MetricValueAggregatedResponseDto
     */
    valueJsonData?: MetricValueJsonAggregatedValuesDto;
    /**
     * Metric ID
     * @type {number}
     * @memberof MetricValueAggregatedResponseDto
     */
    metricId: number;
}

/**
 * Check if a given object implements the MetricValueAggregatedResponseDto interface.
 */
export function instanceOfMetricValueAggregatedResponseDto(value: object): value is MetricValueAggregatedResponseDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('metricId' in value) || value['metricId'] === undefined) return false;
    return true;
}

export function MetricValueAggregatedResponseDtoFromJSON(json: any): MetricValueAggregatedResponseDto {
    return MetricValueAggregatedResponseDtoFromJSONTyped(json, false);
}

export function MetricValueAggregatedResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricValueAggregatedResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'patientId': json['patientId'],
        'startDate': json['startDate'],
        'valueIntData': json['valueIntData'] == null ? undefined : MetricValueAggregatedValuesDtoFromJSON(json['valueIntData']),
        'valueFloatData': json['valueFloatData'] == null ? undefined : MetricValueAggregatedValuesDtoFromJSON(json['valueFloatData']),
        'valueTextData': json['valueTextData'] == null ? undefined : MetricValueTextAggregatedValuesDtoFromJSON(json['valueTextData']),
        'valueJsonData': json['valueJsonData'] == null ? undefined : MetricValueJsonAggregatedValuesDtoFromJSON(json['valueJsonData']),
        'metricId': json['metricId'],
    };
}

export function MetricValueAggregatedResponseDtoToJSON(json: any): MetricValueAggregatedResponseDto {
    return MetricValueAggregatedResponseDtoToJSONTyped(json, false);
}

export function MetricValueAggregatedResponseDtoToJSONTyped(value?: MetricValueAggregatedResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'startDate': value['startDate'],
        'valueIntData': MetricValueAggregatedValuesDtoToJSON(value['valueIntData']),
        'valueFloatData': MetricValueAggregatedValuesDtoToJSON(value['valueFloatData']),
        'valueTextData': MetricValueTextAggregatedValuesDtoToJSON(value['valueTextData']),
        'valueJsonData': MetricValueJsonAggregatedValuesDtoToJSON(value['valueJsonData']),
        'metricId': value['metricId'],
    };
}

